<template>
    <div>
        <CFTitle title="19. Indicatori suplimentari de proiect"></CFTitle>
        <p class="subtitle">Indicatori suplimentari de rezultat</p>
        <b-table responsive striped hover :fields="fieldsRezultat" :items="itemsRezultat">
            <template v-slot:cell(crt)="data">
                <span class="small-item-table">{{ Number(data.index) + 1 }}</span>
            </template>
            <template v-slot:cell(name)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(um)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(year)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(value)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(total)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(women)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(men)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
        </b-table>
        <p class="mb-2">Indicatorii de rezultat, fac referire la activitățile care sunt finanțate și a căror valoare țintă se măsoară la <strong>sfârșitul perioadei de implementare</strong>.</p>



        <p class="subtitle">Indicatori suplimentari de realizare</p>
        <b-table responsive striped hover :fields="fieldsRealizare" :items="itemsRealizare">
            <template v-slot:cell(crt)="data">
                <span class="small-item-table">{{ Number(data.index) + 1 }}</span>
            </template>
            <template v-slot:cell(name)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(um)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(year)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(total)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(women)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
            <template v-slot:cell(men)="data">
                <span class="small-item-table">{{ data.value }}</span>
            </template>
        </b-table>
        <p class="mb-5">Indicatorii de realizare, reprezintă rezultatele directe / avantajele pe care le obțin beneficiarii, și a căror valoare se măsoară <strong>la sfârșitul perioadei de durabilitate</strong>, conform contractului de finanțare (începe în prima zi <strong>după finalizarea perioadei de implementare</strong>).</p>

    </div>
</template>

<script>
    import CFTitle from "./CFTitle";
    import { BFormRadio, BTable} from "bootstrap-vue";
    export default {
        name: "CFIndicatoriSuplimentari",
        components: {
            CFTitle,
            BFormRadio,
            BTable
        },
        props:{
            data: {
                type: Object,
                default: null
            }
        },
        data() {
            return {
                completed: false,
                fieldsRezultat: [
                    {
                        key: 'crt',
                        label: 'Nr. Crt.',
                        thClass: 'fixed-width'
                    },
                    {
                        key: 'name',
                        label: 'Denumire indicator',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'um',
                        label: 'Unitate măsură',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'year',
                        label: 'An',
                    },
                    {
                        key: 'value',
                        label: 'Valoare de referință',
                    },
                    {
                        key: 'total',
                        label: 'Total',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'women',
                        label: 'Femei',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'men',
                        label: 'Bărbați',
                        thClass: 'fixed-width-um'
                    }
                ],
                itemsRezultat: [],
                fieldsRealizare: [
                    {
                        key: 'crt',
                        label: 'Nr. Crt.',
                        thClass: 'fixed-width'
                    },
                    {
                        key: 'name',
                        label: 'Denumire indicator',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'um',
                        label: 'Unitate măsură',
                        thClass: 'fixed-width-title'
                    },
                    {
                        key: 'year',
                        label: 'An',
                    },
                    {
                        key: 'total',
                        label: 'Total',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'women',
                        label: 'Femei',
                        thClass: 'fixed-width-um'
                    },
                    {
                        key: 'men',
                        label: 'Bărbați',
                        thClass: 'fixed-width-um'
                    },
                ],
                itemsRealizare: []
            }
        },
        mounted() {
            this.$store.dispatch('finantare/addToProgress', 'Indicatori suplimentari');
            if(this.data && this.data.m3_project && this.data.m3_project.indicators && this.data.m3_project.indicators.indicators){
                if(this.data.m3_project.indicators.indicators.supResult && this.data.m3_project.indicators.indicators.supResult.length){
                    this.data.m3_project.indicators.indicators.supResult.forEach(result => {
                        this.itemsRezultat.push({
                            name: result.title,
                            um: '% (cifra de afaceri împărțită la numărul mediu de angajați, așa cum a fost declarat în bilanț - anul de referință este 2019)',
							year: '2026',
							year_reference: '2019',
                            value: '2019',
                            total: result.number + (result.hasPercent ? '%' : ''),
                            women: 'N/A',
                            men: 'N/A',
                        },)
                    })
                }
                if(this.data.m3_project.indicators.indicators.supAchievement){
                    this.itemsRealizare.push({
                        crt: '1',
                        name: this.data.m3_project.indicators.indicators.supAchievement.title,
                        um: 'Produs / serviciu inovativ',
                        year: '2026',
                        total: this.data.m3_project.indicators.indicators.supAchievement.number,
                        women: 'N/A',
                        men: 'N/A',
                    },)
                }
            }
        },
        methods: {
        }
    }
</script>

<style scoped>
.subtitle{
  margin-top: 20px;
  font-weight: bold;
}
.small-item-table{
  display: flex;
  width: 100%;
  justify-content: center
}
table >>> .fixed-width{
    width: 6%;
}
table >>> .fixed-width-title{
    width: 33%;
}
table >>> .fixed-width-um{
    width: 4%;
}
table >>> .fixed-width-region{
    width: 17.5%;
}
</style>
